"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const react_1 = __importDefault(require("react"));
const lab_1 = require("@mui/lab");
const TextField_1 = require("./forms/TextField");
exports.DatePicker = (props) => {
    const { onChange } = props;
    const onDateChange = (date, _keyboardInputValue) => {
        if (date) {
            onChange(date);
        }
    };
    return (react_1.default.createElement(lab_1.DatePicker, Object.assign({}, props, { onChange: onDateChange, renderInput: textFieldProps => react_1.default.createElement(TextField_1.TextField, Object.assign({}, textFieldProps)) })));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0ZVBpY2tlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RhdGVQaWNrZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7Ozs7OztBQUVILGtEQUEwQjtBQUMxQixrQ0FBd0U7QUFHeEUsaURBQThDO0FBUWpDLFFBQUEsVUFBVSxHQUFHLENBQVMsS0FBOEIsRUFBRSxFQUFFO0lBQ25FLE1BQU0sRUFBRSxRQUFRLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFFM0IsTUFBTSxZQUFZLEdBQUcsQ0FBQyxJQUFrQixFQUFFLG1CQUE0QixFQUFFLEVBQUU7UUFDeEUsSUFBSSxJQUFJLEVBQUU7WUFDUixRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7U0FDaEI7SUFDSCxDQUFDLENBQUM7SUFFRixPQUFPLENBQ0wsOEJBQUMsZ0JBQWEsb0JBQ1IsS0FBSyxJQUNULFFBQVEsRUFBRSxZQUFZLEVBQ3RCLFdBQVcsRUFBRSxjQUFjLENBQUMsRUFBRSxDQUFDLDhCQUFDLHFCQUFTLG9CQUFLLGNBQWMsRUFBSSxJQUNoRSxDQUNILENBQUM7QUFDSixDQUFDLENBQUMifQ==